/**
 * @generated SignedSource<<aaef18da15eac4f37e0b69a633549c66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgSpaceEditUpdateMutation$variables = {
  id: string;
  name: string;
};
export type OrgSpaceEditUpdateMutation$data = {
  readonly storecastSpace: {
    readonly updateSpace: {
      readonly id: string;
      readonly name: string | null;
    };
  } | null;
};
export type OrgSpaceEditUpdateMutation = {
  response: OrgSpaceEditUpdateMutation$data;
  variables: OrgSpaceEditUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "StorecastSpaceMutation",
    "kind": "LinkedField",
    "name": "storecastSpace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "setName",
                "variableName": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "StorecastSpace",
        "kind": "LinkedField",
        "name": "updateSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSpaceEditUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgSpaceEditUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "959da5f87290e46e5d2785d3edaaaa11",
    "id": null,
    "metadata": {},
    "name": "OrgSpaceEditUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OrgSpaceEditUpdateMutation(\n  $id: ID!\n  $name: String!\n) {\n  storecastSpace(id: $id) {\n    updateSpace(input: {setName: $name}) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a0f47864d4ea7d8e689df0cf7f2ab67";

export default node;
